import { useCourseTranchesOptions } from "api/hooks";
import { PricesPreview } from "./PricesPreview";
import React from "react";
import { PaymentPolicyForm, PaymentPolicyFormValues } from "./PaymentPolicyForm";

import { TabContent, TabGrid, TabHeader } from "../TabLayout";
import { getApiErrorMessage, useToaster } from "utils";
import { coursetranchesApi } from "api";
import { queryClient } from "main";
import { QUERIES_KEYS } from "queries";
import { useCourseQuery } from "../useCourseQuery";
import { EmptyState } from "components/molecules";
import { PaziaBox } from "components/atoms";

export const PaymentPolicyStep = ({ courseId }: { courseId: number }) => {
  const { showError, showSuccess } = useToaster();
  const { course } = useCourseQuery(courseId);

  const { isLoading: loadingTranches, options: tranchesOptions } = useCourseTranchesOptions(courseId);

  if (loadingTranches || !course.data) return null;

  const onSubmitNewTranche = async (data: PaymentPolicyFormValues) => {
    try {
      await coursetranchesApi.createTranchePolicy(Number(courseId), data);
      queryClient.refetchQueries({ queryKey: QUERIES_KEYS.COURSE_TRANCHES_PRICES(courseId!) });
      showSuccess("Pomyślnie dodano politykę cenową");
    } catch (error) {
      console.error(error);
      showError(getApiErrorMessage(error, "Nie udało się dodać polityki cenowej"));
    }
  };

  const { dateOfCourse, endOfCourse } = course.data;
  return (
    <TabContent>
      <TabGrid>
        <PaziaBox className="flex justify-between lg:col-span-2">
          <div>
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Polityka cen</h2>
            <div className="mb-2 text-sm">Dodawaj rabaty i polityki cenowe dla kursu.</div>
          </div>
          <div></div>
        </PaziaBox>
        {!course.data.dateOfCourse || !course.data.endOfCourse ? (
          <PaziaBox className="lg:col-span-2">
            <EmptyState
              title="Brak zjazdów"
              description="Nie skonfigurowano jeszcze żadnych zjazdów dla tego kursu. Przejdź do zakładki Zjazdy i dodaj nowy."
            />
          </PaziaBox>
        ) : (
          <>
            <PaymentPolicyForm optionsTraches={tranchesOptions} onSubmit={onSubmitNewTranche} />
            <PricesPreview courseEnd={endOfCourse} courseId={courseId} />
          </>
        )}
      </TabGrid>
    </TabContent>
  );
};
